import { Space, Tabs, Badge } from 'antd';

function hasCount(count) {
  return count !== null && count !== undefined;
}

function capitalizeFirstLetter(value) {
  const label = String(value);

  return label.charAt(0).toUpperCase() + label.slice(1);
}

function normalizeTab(tab, index) {
  if (!tab || typeof tab !== 'object') return null;

  const key = tab.key ?? tab.value ?? tab.id ?? String(index);
  const title = tab.title ?? tab.tabTitle ?? tab.label ?? tab.name;
  const count = tab.count ?? tab.countValue;

  if (!key || !title) return null;

  return {
    ...tab,
    key: String(key),
    label: (
      <Space size={6}>
        <span>{capitalizeFirstLetter(title)}</span>
        {hasCount(count) && (
          <Badge
            className="dynamic-tabs-count"
            count={count}
            // antd hides a zero count unless told otherwise, so a tab with
            // nothing in it rendered bare — indistinguishable from a tab whose
            // count had not loaded yet. `hasCount` above already lets 0 through;
            // this is what makes it visible. StylishDynamicTabs does the same.
            showZero
            overflowCount={Number.MAX_SAFE_INTEGER}
          />
        )}
      </Space>
    ),
  };
}

export default function DynamicTabs({
  tabs = [],
  activeKey,
  onChange,
  className,
  extra,
}) {
  const items = tabs
    .map(normalizeTab)
    .filter(Boolean);

  if (!items.length) return null;

  const selectedKey = items.some((tab) => tab.key === activeKey)
    ? activeKey
    : items[0].key;

  return (
    <Tabs
      activeKey={selectedKey}
      className={className}
      items={items}
      onChange={onChange}
      tabBarExtraContent={extra}
    />
  );
}
